export default __webpack_public_path__ + "static/media/precios_LEED_feb_V.368c4f7c.png";